import AddBankAccount from "@/views/info/AddBankAccount";
import AddCryptoAccount from "@/views/info/AddCryptoAccount";
import AddOthersAccount from "@/views/info/AddOthersAccount";
import BankInformation from "@/views/info/BankInformation";

export default {
  BankInformation,
  AddBankAccount,
  AddOthersAccount,
  AddCryptoAccount,
};